/**
 * CompositeFieldSidebarContent
 *
 * Body of the composite field drawer, mounted by `CompositeFieldSidebar` only
 * once the sidebar state is ready and keyed by `fieldId`. Routes between entity
 * mode (`EntityModeContent`, which needs the cell proxy and renders nothing
 * without it) and composite-field-type mode (`CompositeFieldTypeContent`).
 * `entityId` wins when both identifiers are present.
 */

import { FC } from 'react';
import { getCellValueProxy } from '../compositeFieldSidebarState';
import { EntityModeContent } from './EntityModeContent';
import { CompositeFieldTypeContent } from './CompositeFieldTypeContent';

type ContentProps = {
  compositeFieldTypeId: string | null;
  entityId: string | null;
  fieldId: string;
  isFormulaColumn: boolean;
  tableMode: boolean;
};

export const CompositeFieldSidebarContent: FC<ContentProps> = ({
  compositeFieldTypeId,
  entityId,
  fieldId,
  isFormulaColumn,
  tableMode,
}) => {
  const cellProxy = getCellValueProxy();

  if (entityId) {
    if (!cellProxy) return null;
    return <EntityModeContent entityId={entityId} cellProxy={cellProxy} />;
  }

  if (!compositeFieldTypeId) return null;

  return (
    <CompositeFieldTypeContent
      compositeFieldTypeId={compositeFieldTypeId}
      fieldId={fieldId}
      isFormulaColumn={isFormulaColumn}
      tableMode={tableMode}
    />
  );
};
